var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8919_11440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.0625V10.5625H16.5V9.0625H13.5ZM12 14.02C12.72 14.5525 13.6575 15.2575 14.4 15.8125C14.7 15.415 15 15.01 15.3 14.6125C14.5575 14.0575 13.62 13.3525 12.9 12.8125C12.6 13.2175 12.3 13.6225 12 14.02ZM15.3 5.0125C15 4.615 14.7 4.21 14.4 3.8125C13.6575 4.3675 12.72 5.0725 12 5.6125C12.3 6.01 12.6 6.415 12.9 6.8125C13.62 6.2725 14.5575 5.575 15.3 5.0125ZM3 7.5625C2.175 7.5625 1.5 8.2375 1.5 9.0625V10.5625C1.5 11.3875 2.175 12.0625 3 12.0625H3.75V15.0625H5.25V12.0625H6L9.75 14.3125V5.3125L6 7.5625H3ZM11.625 9.8125C11.625 8.815 11.19 7.915 10.5 7.3V12.3175C11.19 11.71 11.625 10.81 11.625 9.8125Z",
    fill: "#23BA50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8919_11440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.8125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/notice.cb76e20ba9abdea761b7c8a7cc8bb0f7.svg";
export { ForwardRef as ReactComponent };